export const layout = {
  font: {
    family: 'Roboto, sans-serif'
  },

  colorway: ['#4285F4', '#DB4437', '#F4B400', '#3F51B5', '#E91E63', '#9C27B0', '#673AB7', '#F44336', '#2196F3', '#03A9F4', '#00BCD4', '#009688'],

  xaxis: {
    rangeslider: {
      visible: false,
      borderwidth: 0
    },

    zerolinecolor: '#9E9E9E',

    gridcolor: '#E0E0E0',

    titlefont: {
      color: '#424242',
      size: 12
    },

    tickfont: {
      color: '#757575',
      size: 12
    },

    showgrid: false
  },

  yaxis: {
    zerolinecolor: '#9E9E9E',

    gridcolor: '#E0E0E0',

    titlefont: {
      color: '#424242',
      size: 12
    },

    tickfont: {
      color: '#757575',
      size: 12
    }
  },

  bargroupgap: 0.01,

  legend: {
    font: {
      size: 16
    }
  }
}



// WEBPACK FOOTER //
// ./src/layout.js